<template>
  <li
    class="d-flex align-items-center justify-content-center flex-column w-100"
    :class="{
      'is-origin' : isOrigin,
      'disabled-item' : isLocked,
      'first' : !index,
      'last' : index === elements.length -1 ,
    }"
    :style="`--accent-nav: ${element.accentColor};`"
  >
    <router-link :to="{path: element.path}" @click.native="element.redirectTo ? redirectTo(element.redirectTo): ''">
      <component :is="isLocked ? 'lock-icon' : element.icon" :title="element.description" /> <span class="text-navbar">
        {{titleNav}}
      </span>
    </router-link>

    <ul
      v-if="showExpanded && nestedRoutes && nestedRoutes.length"
      class="align-items-center justify-content-center mx-0 w-100 row ml-0 pl-0 d-lg-flex d-none sub-level-1"
    >
      <SideNavItem
        v-for="(item, i) in nestedRoutes"
        :key="i" 
        :index="i"
        :element="item"
        :elements="nestedRoutes"
        :is-origin="false"
    />
    </ul>
  </li>
</template>

<script>
import SideNavItem from './SideNavItem';
import { redirectTo } from '@/common/constants/routes';
export default {
  name: "SideNavItem",
  components: {
    SideNavItem
  },
  methods: {
    redirectTo
  },
  computed: {
    titleNav() {
      const splitedNavTitle = this.element.title.split(" ");
      // element.title.length > 10 ? `${element.title.slice(0,7)}...` : element.title
      if(this.element.title.length <= 10) {
        return this.element.title;
      }
      
      if(splitedNavTitle.length == 1) {
        return `${this.element.title.slice(0,7)}...`;
      }

      const firstWord = `${splitedNavTitle[0].charAt(0)}.`;
      let restPhrase = splitedNavTitle.filter((val, i) => i).join(" ");

      if(restPhrase.length > 6) {
        restPhrase = `${restPhrase.slice(0, 4)}...`;
      }
      
      return `${firstWord} ${restPhrase}`;
    },
    isLocked() {
      return !!this.element.isLocked;
    },
    showExpanded() {
      return this.$route.path.includes(this.element.path);
    },
    nestedRoutes() {
      if(!(this.element.nestedRoutes && this.element.nestedRoutes.length)) {
        return [];
      }

      return this.element.nestedRoutes.map(nestedRoute => {
        nestedRoute.path = this.element.path + nestedRoute.path;

        return nestedRoute;
      }).filter(route => !route.isLocked && !route.hideInMenu);
    }
  },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    elements: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    },
    isOrigin: {
      type: Boolean,
      default: true
    },
    accentColor: {
      type: String,
      default: ""
    },
  },
}
</script>

<style scoped>

li:not(.is-origin){
  height: 55px !important;
}

ul {
  /* height: 0; */
  /* overflow: hidden; */
  background-color: var(--accent-nav);
}

.is-origin .sub-level-1{
  transition: all 0.5s !important;
  transition-delay: 0.2s !important;
}

.sub-level-1 > * {
  height: 55px !important;
}

/* .is-origin:hover .sub-level-1 {
  height: 400px !important;
  max-height: fit-content;
  transition: all 0.3s !important;
  transition-delay: 0.1s !important;
} */

.text-navbar {
  font-size: 0.52em;
  text-transform: uppercase;
  font-weight: 500;
}
.text-blocked{
  color: var(--background-white);
}
/* .router-link-active {
  background-color: #ffffffb7;
} */
.sideNav .sidebar li .bell .err-notif-server {
  color: var(--red-color-primary);
}
a.router-link-exact-active {
  color: var(--accent-nav);
  background-color: #fbfbfb;
  /* color: #f0f0f0; */
}
.sub-level-1 a:not(.router-link-active),
a.router-link-active:not(.router-link-exact-active) {
  /* color: var(--orange-color); */
  background-color: var(--accent-nav);
}

.sub-level-1 a:not(.router-link-active):hover {
  filter: brightness(0.8)
}

.qaReg a.router-link-active {
  color: var(--orange-color);
  background-color: #fbfbfb;
}
.qaConfig a.router-link-active {
  color: #5bb2e1;
}
.qaMonit a.router-link-active:hover,
.qaReg a.router-link-active:hover,
.qaConfig a.router-link-active:hover {
  background-color: var(--background-white);
}
li a {
  display: block;
  color: #f4f4f4;
  padding: 6px 1px;
  line-height: 16px;
  text-decoration: none;
  width: 100%;

  height: var(--side-nav-icon-height) !important;
}
.material-design-icon{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 1.4em;
}
li a:hover {
  transition: all 0.4s;
  filter: brightness(0.8);
  
}
li.qaMonit a:hover {
  background-color: #ffffff4a;
}
li.qaReg a:hover {
  background-color: #ffffff4a;
}
</style>